import React from 'react'
import amns from "swfrontend/assets/images/amns_transparent.png"
import NewDPR from '../NewDPR/NewDPR';

const VendorInputs = () => {

    return (
        <>
            <div style={{ backgroundColor: "white", textAlign: "center" }}>
                <img src={amns} alt="" style={{ width: "150px" }} />
            </div>

            
            <div style={{ padding: "2% 10%" }}>
                <NewDPR isVendorForm={true} />
            </div>
        </>
    )
}

export default VendorInputs;
